import { z } from 'zod';

export const DocumentQueryItemSchema = z.object({
  matricula: z.string(),
  direccion: z.string(),
});

export const DocumentQueryResponseSchema = z.object({
  status: z.number(),
  message: z.string(),
  data: z.array(DocumentQueryItemSchema),
});

export type DocumentQueryItem = z.infer<typeof DocumentQueryItemSchema>;
export type DocumentQueryResponse = z.infer<typeof DocumentQueryResponseSchema>;

export const DocumentQueryRequestSchema = z.object({
  documentId: z.string().min(1, "El número de documento es requerido").max(15, "El documento es demasiado largo"),
});
export type DocumentQueryRequest = z.infer<typeof DocumentQueryRequestSchema>;

export type DocumentQueryItemWithDoc = DocumentQueryItem & {
  document?: string;
};
